<template>
  <div>
    <title_header :title="headerTitle" />
    <div class="news_box">
      <div class="box_flex">
        <div class="box_left">
          <title_list_component
            :title="title"
            :titleList="titleList"
            @changeIndex="changeIndex"
          />
          <customer class="margin_top" :info="info" />
        </div>
        <div class="box_right">
          <aboutus_content :contentDetail="contentDetail" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import title_header from "../../components/title_header";
import title_list_component from "../../components/title_list_component";
import customer from "../../components/customer";
import aboutus_content from "../../components/content";

export default {
  components: {
    title_header,
    title_list_component,
    customer,
    aboutus_content,
  },
  props: { info: Object },
  data() {
    return {
      title: "公司信息",
      headerTitle: "公司信息",
      titleList: [
        { name: "关于我们" },
        { name: "发展历程" },
        { name: "荣誉资质" },
      ],
      contentDetail: {
        title: "",
        content: "",
      },
    };
  },
  methods: {
    changeIndex(index) {
      this.headerTitle = this.titleList[index].name;
      this.contentDetail = this.info.wxSchoolPageItemList[index] = {
        title: this.titleList[index].name,
        content: this.info.wxSchoolPageItemList[index].content,
      };
    },
  },
  mounted() {
    this.contentDetail.content = this.info.wxSchoolPageItemList[0].content;
  },
};
</script>

<style lang="less" scoped>
.news_box {
  background-color: #ffffff;
  width: 1200px;
  margin: auto;
}

.box_flex {
  display: flex;
}

.margin_top {
  margin-top: 20px;
}

.box_left {
  padding: 10px;
  width: 300px !important;
  flex-shrink: 0;
}

.box_right {
  width: 100%;
  padding: 10px;
}

.box_pagination {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/designPage/template/module/module2/index.vue